import React, {useEffect, useState} from 'react';
import {ColorIcon} from '../../ui-components/Iconpack';
import {Button} from '../../ui-components/Button/button';
import {TransformValues} from '../../utils/helper';
import {ColorPicker, useColor} from 'react-color-palette';
import 'react-color-palette/css';
import Tracker from '../../lib/analytics/tracker';
import {EventNames, EventProperty} from '../../lib/analytics/events';
import {TransformationType} from '../../screens/TransformationV2/Transformation';

interface BackgroundColorProps {
    onTransformValuesChange: (values: {bgColorPalette?: string}) => void;
    transformationObject: TransformValues;
    addTransformation: (t: TransformationType) => void;
}
export default function BackgroundReplacementColor({
    onTransformValuesChange,
    transformationObject,
    addTransformation,
}: BackgroundColorProps) {
    let isSvgOrGif = false;
    const [bgColor, setBgColor] = useColor(
        transformationObject.bgColorPalette ? transformationObject.bgColorPalette : '#561ecb',
    );
    const [bgColorPalette, setBgPaletteColor] = useState('');

    const presetArray = [
        '#FFFFFF',
        '#000000',
        '#FF4405',
        '#F63D68',
        '#c707af',
        '#875BF7',
        '#444CE7',
        '#444CE8',
        '#0BA5EC',
        '#0BA5ED',
        '#15B79E',
        '#17B26A',
        '#66C61C',
        '#FAC515',
        '#FAC516',
        '#F38744',
        '#A15C07',
        '#854A0E',
        '#98A2B3',
        '#667085',
        '#98A2B4',
        '#D0D5DD',
        '#EAECF0',
        '#DEDEDE',
        '#F7F7F7',
    ];

    const handleSelectedBgColor = () => {
        setBgPaletteColor(bgColor.hex);
    };
    const handlePaletteColor = (paletteColor: string) => {
        setBgPaletteColor(paletteColor);
    };

    useEffect(() => {
        if (bgColorPalette) {
            Tracker.trackEvent(EventNames.TRANSFORMATION_BACKGROUND_REPLACED_COLOUR, {
                [EventProperty.BackgroundColour]: bgColorPalette,
            });
            onTransformValuesChange({bgColorPalette});
            addTransformation(TransformationType.BG_CLR);
            transformationObject.bgColorPalette = bgColorPalette;
        }
    }, [bgColorPalette]);

    useEffect(() => {
        if (transformationObject.bgColorPalette) {
            setBgPaletteColor(transformationObject.bgColorPalette);
        }
    }, []);

    return (
        <>
            <div className='mt-4 flex items-center justify-center gap-5 md:flex-col'>
                <ColorPicker
                    color={bgColor}
                    onChange={setBgColor}
                    hideInput={['hsv', 'rgb']}
                    height={195}
                    hideAlpha={true}
                />
                {!isSvgOrGif ? (
                    <>
                        <Button
                            variant='secondary'
                            size='lg'
                            className='hidden w-[183px] rounded-button text-[12px] font-[700] text-[#155EEF] md:flex'
                            icon
                            onClick={handleSelectedBgColor}>
                            <ColorIcon />
                            Apply colour
                        </Button>
                        <Button
                            variant='secondary'
                            size='sm'
                            className='flex h-10 rounded-button text-[12px] font-[700] text-[#155EEF] md:hidden'
                            icon
                            onClick={handleSelectedBgColor}>
                            <ColorIcon />
                            Apply colour
                        </Button>
                    </>
                ) : (
                    <span className='flex flex-col items-center justify-center pl-[6px] text-[14px] font-[700] text-[#FFFFFF]'>
                        Action not allowed for this image type
                    </span>
                )}
            </div>
            <div className='flex items-center'>
                <div className='mt-8 flex flex-col pl-[6px] text-[14px] font-[700] text-[#FFFFFF] md:pl-0'>
                    <span>Presets</span>
                </div>
            </div>
            <div className='mt-4 grid grid-cols-7 items-center justify-center gap-2 md:grid-cols-5'>
                {presetArray.map((color) => (
                    <div
                        key={color}
                        className={`flex h-7 w-7 cursor-pointer rounded-[4px]`}
                        style={{backgroundColor: color, border: color === bgColorPalette ? '1px solid white' : 'none'}}
                        onClick={() => {
                            handlePaletteColor(color);
                        }}></div>
                ))}
            </div>
        </>
    );
}
